<template>
  <div class="content">
    <div class="days-forecast">
      <div class="publish-time" v-if="showTime && giftData.ddatetime">
        <!--        数据时间：{{ $moment(giftData.ptimestemp).format('YYYY-MM-DD HH:mm') }}-->
        <!-- <div>{{ giftData.ddatetime }}更新</div> -->
      </div>
      <div class="days-forecast-list">
        <div class="item" v-for="(item, index) in giftData.mint" :key="index" v-show="index < 7">
          <span>{{ giftData.date[index] }}</span>
          <el-tooltip effect="dark" placement="top">
            <img :src="require(
              `@/assets/images/weatherIcon_p/${giftData.icon[index]}.png`,
            )
              " />
            <div slot="content">
              <div>{{ giftData.desc[index] }}</div>
            </div>
          </el-tooltip>
          <!-- <span>{{ giftData.mint[index] }}℃ - {{ giftData.maxt[index] }}℃</span> -->

        </div>
        <div class="chart" id="temp-chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { getDaysForecastOption } from '@/config/echarts/option/index.js'
import echarts from '@/config/echarts/index.js'

export default {
  // props: ['params', 'forecastType'],
  props: {
    forecastType: {
      type: Number,
      default: 0,
    },
    showTime: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      giftData: {},
      charts: '',
    };
  },
  watch: {
    activeCountyId: {
      handler() {
        setTimeout(() => {
          this.getGiftData();
        }, 100);
      },
      immediate: true,
    },
    forecastType() {
      this.resetEchart();
    },
    sevenDayDataResult: {
      handler() {
        this.$nextTick(() => {
          this.getGiftData();
        });
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("home", ["objsList", "activeCountyId", "sevenDayDataResult"]),
  },
  mounted() {
    this.$bus.$on("changeForest", (data) => {
      this.getGiftData();
    });
  },
  methods: {
    initEchart() {
      const tempChart = echarts.init(document.getElementById('temp-chart'))
      tempChart.setOption(getDaysForecastOption())
      this.charts = tempChart
      // 页面缩放
      window.onresize = () => {
        Vue.prototype.$rootFontSize = document.body.clientWidth / 1920 * 16
        document.getElementsByTagName('html')[0].style.fontSize = this.$rootFontSize + 'px'
        this.charts.resize()
      }
      const options = tempChart.getOption()

      // ✅ 1. 左右分散：增大 grid 左右间距 + 开启 boundaryGap
      options.grid = {
        left: '6%',
        right: '7%',
        bottom: '20px',
        top: '20%',
      }
      // options.xAxis[0].boundaryGap = true // 折线图默认 false，改为 true 后首尾节点不再贴边
      const mintData = this.giftData.mint.slice(0, 7)
      const maxtData = this.giftData.maxt.slice(0, 7)
      // ✅ 2. 上下分开：手动设置 Y 轴范围，留出呼吸空间
      const allValues = [...mintData, ...maxtData]
      const minVal = Math.min(...allValues)
      const maxVal = Math.max(...allValues)
      options.yAxis = {
        type: 'value',
        axisTick: { show: false },
        axisLabel: { show: false },
        axisLine: { show: false },
        splitLine: { show: false },
        min: Math.floor(minVal - 2),
        max: Math.ceil(maxVal + 2),
      }

      // ✅ 3. 系列配置（顺便修正了 name 重复赋值的 bug）
      options.series[0].data = maxtData
      options.series[0].lineStyle.color = '#ff0000'
      options.series[0].symbol = 'circle'
      options.series[0].itemStyle = { color: '#ff0000' }
      options.series[0].name = '最高温'
      options.series[0].label.formatter = (params) => params.value + '℃'
      options.series[1].data = mintData
      options.series[1].lineStyle.color = '#007aff'
      options.series[1].symbol = 'circle'
      options.series[1].itemStyle = { color: '#007aff' }
      options.series[1].name = '最低温'
      options.series[1].label.formatter = (params) => params.value + '℃'

      tempChart.setOption(options)
      tempChart.resize()
      this.$bus.$on('changeForest', (data) => {
        this.getGiftData(data)
      })

      this.$bus.$on('changeHourForestResize', () => {
        this.$nextTick(() => {
          this.charts.resize()
        })
      })

      this.$bus.$on('changeCardData', () => {
        this.$nextTick(() => {
          this.charts.resize()
        })
      })
    },
    // 获取gif预报
    async getGiftData(data) {
      try {
        const result =
          data || JSON.parse(JSON.stringify(this.sevenDayDataResult));
        if (!result || !result.data) {
          return;
        }
        // console.log('当前选中点位', this.activeCountyId)
        // 根据点位所在区获取对应的位置预报
        const index = this.objsList.findIndex(
          (item) => item.id === this.activeCountyId,
        );
        const county = this.objsList[index].county.replace("区", "");
        console.log("county", county);
        const countyResult = result.data[county] || {};
        // const date = result.data[county].datetime
        // countyResult.icon = countyResult.icon.map(v => String(v).padStart(2, '0'))
        // const dateStr = this.$moment(date).format('YYYY-MM-DD HH:mm')
        // countyResult.datetime = dateStr
        this.giftData = countyResult;
        if (!this.charts) {
          this.initEchart()
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.6vw 1.04vw 0.26vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  // pointer-events: none;

  .hour-forecast {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0vw;

    .hour-forecast-wrap {
      position: relative;
      // top: -2.04vw;
      width: 100%;
      height: 100%;
      overflow: hidden;

      .hour-forecast-list {
        width: 100% !important;
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        transition: all 0.3s linear;

        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 5.58rem;

          span {
            font-size: 0.75rem;
            color: #fff;
          }

          .des {
            font-size: 0.88rem;
            color: #fff;
          }

          img {
            width: 2.25rem;
          }

          .chart {
            height: 90%;
          }

          .wind {
            color: #fff;
          }
        }

        #temp-chart {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
        }
      }
    }

    .left-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/左.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      left: 1.2rem;
      cursor: pointer;
    }

    .right-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/右.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      right: 1.2rem;
      cursor: pointer;
    }
  }

  .days-forecast {
    height: 100%;
    // padding: 8% 3% 0 2%;
    box-sizing: border-box;

    .days-forecast-list {
      display: flex;
      justify-content: space-between;
      height: 100%;
      position: relative;

      .desc {}

      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        width: 6.85rem;
        height: 5rem;

        span {
          font-size: 0.85rem;
          color: #fff;
        }

        font {
          font-size: 0.98rem;
          color: #fff;
        }

        .chart {
          height: 50%;
        }

        img {
          width: 2rem;
        }
      }

      #temp-chart {
        position: absolute;
        left: 0.3rem;
        right: 2.3rem;
        top: 53%;
        height: 45%;
        width: 100%;
      }
    }
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: 0.8vw;
    color: #fff;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}
</style>
